import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import logo from '../assets/logo.png';

const AccountDeleteForm: React.FC = () => {
  const navigate = useNavigate();
  const [deleteFormData, setDeleteFormData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    reason: ''
  });
  const [deleteFormMessage, setDeleteFormMessage] = useState('');

  const handleDeleteFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Form validation
    if (!deleteFormData.email || !deleteFormData.firstName || !deleteFormData.lastName || !deleteFormData.reason) {
      setDeleteFormMessage('Lütfen tüm alanları doldurun.');
      return;
    }

    // Here you would normally send the data to your backend
    console.log('Hesap silme talebi:', deleteFormData);
    
    setDeleteFormMessage('Hesap silme talebiniz alınmıştır. En kısa sürede sizinle iletişime geçeceğiz.');
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setDeleteFormData({
        email: '',
        firstName: '',
        lastName: '',
        reason: ''
      });
      setDeleteFormMessage('');
    }, 3000);
  };

  const handleDeleteFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setDeleteFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="homepage">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="nav">
            <div className="logo">
              <img src={logo} alt="Taxicim Logo" className="logo-img" />
            </div>
            <div className="header-right">
              <button 
                className="login-btn"
                onClick={() => navigate('/')}
              >
                Ana Sayfa
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Account Delete Form Section */}
      <section className="account-delete-page" style={{ padding: '120px 0 80px', minHeight: '100vh', background: '#f8f9fa' }}>
        <div className="container">
          <div className="modal-content" style={{ position: 'static', maxWidth: '600px', margin: '0 auto', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
            <div className="modal-header">
              <h3>Hesap Silme Talebi</h3>
            </div>
            <form onSubmit={handleDeleteFormSubmit} className="delete-form">
              <div className="form-group">
                <label htmlFor="email">E-posta Adresi *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={deleteFormData.email}
                  onChange={handleDeleteFormChange}
                  placeholder="ornek@email.com"
                  required
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName">Ad *</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={deleteFormData.firstName}
                    onChange={handleDeleteFormChange}
                    placeholder="Adınız"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Soyad *</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={deleteFormData.lastName}
                    onChange={handleDeleteFormChange}
                    placeholder="Soyadınız"
                    required
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="reason">Hesap Silme Nedeni *</label>
                <textarea
                  id="reason"
                  name="reason"
                  value={deleteFormData.reason}
                  onChange={handleDeleteFormChange}
                  placeholder="Hesabınızın silinmesi neden istendiğini açıklayın..."
                  rows={4}
                  required
                />
              </div>
              {deleteFormMessage && (
                <div className={`form-message ${deleteFormMessage.includes('alınmıştır') ? 'success' : 'error'}`}>
                  {deleteFormMessage}
                </div>
              )}
              <div className="form-actions">
                <button type="button" onClick={() => navigate('/')} className="cancel-btn">
                  Ana Sayfaya Dön
                </button>
                <button type="submit" className="submit-btn">
                  Talep Gönder
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AccountDeleteForm; 